import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 font-montserrat" }
const _hoisted_2 = { class: "flex flex-row my-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Buat Konversi ", -1)
const _hoisted_4 = { class: "inline-flex" }
const _hoisted_5 = { class: "flex flex-row h-screen py-6" }
const _hoisted_6 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500" }, " Pastikan nilai kurs awal, kurs tukar, dan periode konversi tidak boleh sama dengan data yang sedang aktif. ", -1)
const _hoisted_8 = { class: "flex flex-row" }
const _hoisted_9 = { class: "py-3 w-3/4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kurs awal", -1)
const _hoisted_11 = { class: "inline-block relative w-3/4" }
const _hoisted_12 = { class: "flex-grow truncate" }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = { class: "text-red-lp-100 my-2 text-12px xxl:text-14px flex" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4 max-w-none mr-0.5",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Data kurs sudah ada. ")
const _hoisted_17 = { class: "py-3 w-3/4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kurs tukar", -1)
const _hoisted_19 = { class: "inline-block relative w-3/4" }
const _hoisted_20 = { class: "flex-grow truncate" }
const _hoisted_21 = { class: "font-semibold" }
const _hoisted_22 = { class: "text-red-lp-100 text-12px xxl:text-14px flex" }
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4 max-w-none mr-0.5",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Data exchange rate sudah tersedia ")
const _hoisted_25 = { class: "text-red-lp-100 text-12px xxl:text-14px flex" }
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4 max-w-none mr-0.5",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Kurs awal dan kurs tukar tidak boleh sama ")
const _hoisted_28 = { class: "flex flex-row" }
const _hoisted_29 = { class: "flex flex-row w-3/4" }
const _hoisted_30 = { class: "py-3 w-full" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nilai awal", -1)
const _hoisted_32 = { class: "inline-flex flex-row" }
const _hoisted_33 = { class: "flex flex-row w-3/4" }
const _hoisted_34 = { class: "py-3 w-full" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nilai tukar", -1)
const _hoisted_36 = { class: "inline-flex flex-row" }
const _hoisted_37 = { class: "flex flex-col h-full text-12px border-t border-gray-lp-400 my-6 py-2" }
const _hoisted_38 = { class: "py-3" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tanggal efektif ", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "my-2 text-gray-lp-500" }, " Konfigurasi ini akan berlaku seterusnya sejak tanggal yang dipilih hingga Anda memperbaruinya. ", -1)
const _hoisted_41 = { class: "flex flex-row py-3" }
const _hoisted_42 = { class: "w-3/4" }
const _hoisted_43 = { class: "flex flex-col mr-4 w-11/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_Pickers = _resolveComponent("Pickers")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", {
          src: _imports_0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "w-5 mr-3 cursor-pointer",
          alt: "back"
        }),
        _hoisted_3
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_button_fill, {
          title: "Simpan",
          onClick: _ctx.onOpenSave,
          isDisabled: _ctx.isDisabled,
          class: "px-8"
        }, null, 8, ["onClick", "isDisabled"])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_SelectSearchV2, {
                onFilter: _ctx.fetchCountryCurrency,
                isLoading: _ctx.isLoadingCountry,
                options: _ctx.countryListData,
                keyName: "label",
                keyValue: "value",
                placeholder: "Pilih kurs awal",
                modelValue: _ctx.kursAwal,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.kursAwal = $event)),
                  _ctx.onSelectKursAwal
                ],
                onFocus: _cache[3] || (_cache[3] = () => _ctx.fetchCountryCurrency('')),
                class: "mb-2",
                isError: _ctx.isErrorValidation,
                isShowErrorIndicator: _ctx.isErrorValidation
              }, {
                "custom-option": _withCtx(({ item }) => [
                  _createVNode("span", _hoisted_12, [
                    _createTextVNode(_toDisplayString(item.name) + " - ", 1),
                    _createVNode("span", _hoisted_13, _toDisplayString(item.value), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onFilter", "isLoading", "options", "modelValue", "onUpdate:modelValue", "isError", "isShowErrorIndicator"])
            ]),
            _withDirectives(_createVNode("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16
            ], 512), [
              [_vShow, _ctx.isErrorValidation]
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode("div", _hoisted_19, [
              _createVNode(_component_SelectSearchV2, {
                onFilter: _ctx.fetchCountryCurrency,
                isLoading: _ctx.isLoadingCountry,
                options: _ctx.countryListData,
                keyName: "label",
                keyValue: "value",
                placeholder: "Pilih kurs tukar",
                modelValue: _ctx.kursTukar,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => (_ctx.kursTukar = $event)),
                  _ctx.onSelectKursTukar
                ],
                onFocus: _cache[5] || (_cache[5] = () => _ctx.fetchCountryCurrency('')),
                class: "mb-2",
                isError: _ctx.isErrorValidation || _ctx.isSameCurrency,
                isShowErrorIndicator: _ctx.isErrorValidation || _ctx.isSameCurrency
              }, {
                "custom-option": _withCtx(({item}) => [
                  _createVNode("span", _hoisted_20, [
                    _createTextVNode(_toDisplayString(item.name) + " - ", 1),
                    _createVNode("span", _hoisted_21, _toDisplayString(item.value), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onFilter", "isLoading", "options", "modelValue", "onUpdate:modelValue", "isError", "isShowErrorIndicator"])
            ]),
            _withDirectives(_createVNode("div", _hoisted_22, [
              _hoisted_23,
              _hoisted_24
            ], 512), [
              [_vShow, _ctx.isErrorValidation]
            ]),
            _withDirectives(_createVNode("div", _hoisted_25, [
              _hoisted_26,
              _hoisted_27
            ], 512), [
              [_vShow, _ctx.isSameCurrency]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode("div", _hoisted_32, [
                _createVNode("div", {
                  class: 
                  'bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2'
                ,
                  style: {"min-width":"52px"}
                }, _toDisplayString(_ctx.kursAwal?.value || "-"), 3),
                _createVNode("input", {
                  type: "text",
                  value: _ctx.kursAwal?.value ? 1 : 0,
                  class: 
                  `py-1.5 xxl:py-3 px-3 mr-4 rounded-l-none rounded-r-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-gray-lp-600 w-56 bg-white cursor-not-allowed`
                ,
                  disabled: true
                }, null, 10, ["value"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_33, [
            _createVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode("div", _hoisted_36, [
                _createVNode("div", {
                  class: 
                  'bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2'
                ,
                  style: {"min-width":"52px"}
                }, _toDisplayString(_ctx.kursTukarValue || "-"), 3),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                  maxlength: 15,
                  onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.formatted && _ctx.formatted(...args))),
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.exchangeRateValue = $event)),
                  placeholder: "100,000,000",
                  class: 
                  'py-1.5 xxl:py-3 px-3 mr-4 rounded-l-none rounded-r-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-56'
                
                }, null, 34), [
                  [_vModelText, _ctx.exchangeRateValue]
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_37, [
          _createVNode("div", _hoisted_38, [
            _hoisted_39,
            _hoisted_40,
            _withDirectives(_createVNode("span", { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.isErrorValidation]
            ])
          ]),
          _createVNode("div", _hoisted_41, [
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _createVNode(_component_Pickers, {
                  modelValue: _ctx.effectiveDate,
                  onSelected: _ctx.inputEffectiveDate,
                  minDate: _ctx.minDate,
                  class: `${_ctx.isErrorValidation ? 'border-red-lp-100' : ''}`
                }, null, 8, ["modelValue", "onSelected", "minDate", "class"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Konversi kurs ditambahkan.",
      message: 
      `Konversi kurs "${_ctx.kursAwal?.value} - ${_ctx.kursTukarValue}" telah berhasil dibuat.`
    ,
      image: "image-modal-success",
      textSuccess: "Ok",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onCreate,
      onClose: _ctx.onCloseSave,
      title: "Simpan konversi kurs?",
      message: "Pastikan detail yang Anda isi telah sesuai. ",
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.openSave]
    ])
  ], 64))
}